//#region ../../packages/components/tooltip/src/constants.ts
const TOOLTIP_INJECTION_KEY = Symbol("elTooltip");

//#endregion
export { TOOLTIP_INJECTION_KEY };
//# sourceMappingURL=constants.mjs.map